module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d8dd2b39212eb3a266949b79ed400639.png";